import lib from "i18n-js";

// Make sure that we are always using one global instance of I18n
// Because it's properties like `locale` `defaultLocale` will be modified from global/window scope.
export const I18n = global.I18n || lib;
global.I18n = I18n;
